// Comportamento "griglia con carica altro/mostra meno" condiviso da
// archivio-servizi.js (con ricerca live, che filtra gli elementi prima di
// applicare il limite) e gallery.js (senza ricerca, lista fissa):
// mostra solo le prime `initialCount` voci restituite da getItems(), le altre
// restano [hidden] finché non si preme "Carica altro" (che ne rivela altre
// `loadIncrement` alla volta) o "Mostra meno" (che le nasconde di nuovo, fino
// a `initialCount`). Ogni chiamante gestisce tramite onRender ciò che gli è
// specifico (etichetta "mostrati X di Y", elementi "big", messaggio vuoto).
export function createLoadMoreGrid({
    getItems,
    initialCount,
    loadIncrement,
    loadMoreWrap,
    loadMoreButton,
    showLessButton,
    onRender,
}) {
    let visibleLimit = initialCount;

    function render() {
        const items = getItems();
        const total = items.length;
        const shown = Math.min(visibleLimit, total);

        items.forEach((item, index) => {
            item.hidden = index >= visibleLimit;
        });

        if (loadMoreWrap) {
            loadMoreWrap.hidden = total <= initialCount;
        }

        if (loadMoreButton) {
            loadMoreButton.hidden = shown >= total;
        }

        if (showLessButton) {
            showLessButton.hidden = visibleLimit <= initialCount;
        }

        onRender({ items, shown, total, visibleLimit });
    }

    if (loadMoreButton) {
        loadMoreButton.addEventListener("click", () => {
            visibleLimit += loadIncrement;
            render();
        });
    }

    if (showLessButton) {
        showLessButton.addEventListener("click", () => {
            visibleLimit = Math.max(initialCount, visibleLimit - loadIncrement);
            render();
        });
    }

    return {
        render,
        // Riparte da initialCount (es. quando cambia la ricerca) e ridisegna subito.
        reset() {
            visibleLimit = initialCount;
            render();
        },
    };
}
